/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { networkIngressCheckHealth } from "../funcs/networkIngressCheckHealth.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { NetworkIngress } from "../models/components/networkingress.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CheckNetworkIngressHealthRequest,
  CheckNetworkIngressHealthSecurity,
} from "../models/operations/checknetworkingresshealth.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type NetworkIngressCheckHealthMutationVariables = {
  request?: CheckNetworkIngressHealthRequest | undefined;
  security?: CheckNetworkIngressHealthSecurity | undefined;
  options?: RequestOptions;
};

export type NetworkIngressCheckHealthMutationData = NetworkIngress;

export type NetworkIngressCheckHealthMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * checkHealth networkIngress
 *
 * @remarks
 * Signal reconciliation and return the latest observed ingress health.
 */
export function useNetworkIngressCheckHealthMutation(
  options?: MutationHookOptions<
    NetworkIngressCheckHealthMutationData,
    NetworkIngressCheckHealthMutationError,
    NetworkIngressCheckHealthMutationVariables
  >,
): UseMutationResult<
  NetworkIngressCheckHealthMutationData,
  NetworkIngressCheckHealthMutationError,
  NetworkIngressCheckHealthMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildNetworkIngressCheckHealthMutation(client, options),
    ...options,
  });
}

export function mutationKeyNetworkIngressCheckHealth(): MutationKey {
  return ["@gram/client", "networkIngress", "checkHealth"];
}

export function buildNetworkIngressCheckHealthMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: NetworkIngressCheckHealthMutationVariables,
  ) => Promise<NetworkIngressCheckHealthMutationData>;
} {
  return {
    mutationKey: mutationKeyNetworkIngressCheckHealth(),
    mutationFn: function networkIngressCheckHealthMutationFn({
      request,
      security,
      options,
    }): Promise<NetworkIngressCheckHealthMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(networkIngressCheckHealth(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
